
module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <g stroke=\"#999\">             <g transform=\"translate(-327.000000, -529.000000) translate(327.000000, 529.000000)\">                 <rect width=\"15\" height=\"15\" x=\".5\" y=\".5\" rx=\"2\"/>             </g>         </g>     </g>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)



//////////////////
// WEBPACK FOOTER
// ./assets/posttruck/checkbox.svg
// module id = 705
// module chunks = 0